module.exports = __webpack_public_path__ + "static/media/logo4 1 (2).aefb7329.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MobileApp/logo4 1 (2).svg
// module id = 988
// module chunks = 0